import { fetchMarketsApi } from 'api/applications/fetchers/fetchMarkets'
import { createUseQuery } from 'api/common/createUseQuery'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useMarketsApi = createUseQuery({
  queryKey: ApiQueryKeys.MARKETS,
  fetcher: fetchMarketsApi,
  selector: res => res?.data || [],
})
